import { FileDetailsResponse, Path, UserDetailsDto } from '../../generated';
import { FileDetails } from '../../models/file/file-details.types';

export const mapToDomainFileDetails = (
  value: FileDetailsResponse
): FileDetails => {
  return {
    ...value,
    path: parsePath(value.path),
    createdBy: parseUserDetailsDto(value.createdBy),
    modifiedBy: parseUserDetailsDto(value.modifiedBy),
  };
};

/**
 * Helper to safely parse path that is declared as `string | undefined`
 * but in reality return a {@link Path} array object.
 *
 * See {@link FileDetailsResponse}
 */
function parsePath(value: string | Path[] | undefined): Path[] | undefined {
  if (!value) return undefined;

  if (Array.isArray(value)) {
    return value.every(isPath) ? value : undefined;
  }

  return undefined;
}

const pathFields = ['id', 'name', 'versionId'] satisfies (keyof Path)[];

function isPath(value: unknown): value is Path {
  return (
    value !== null &&
    typeof value === 'object' &&
    pathFields.every((key) => key in value)
  );
}

/**
 * Helper to safely parse createBy and modifiedBy that are declared as `string | undefined`
 * but in reality return a {@link UserDetailsDto} object.
 *
 * See {@link FileDetailsResponse}
 */
function parseUserDetailsDto(
  value: string | UserDetailsDto | undefined
): UserDetailsDto | undefined {
  if (!value) return undefined;
  if (isUserDetailsDto(value)) return value;

  return undefined;
}

const userFields = [
  'tiduuid',
  'firstName',
  'lastName',
] satisfies (keyof UserDetailsDto)[];

function isUserDetailsDto(value: unknown): value is UserDetailsDto {
  return (
    value !== null &&
    typeof value === 'object' &&
    userFields.every((key) => key in value)
  );
}
